













import { filename } from 'paths.macro'
import Vue from 'vue'

export default Vue.component(filename, {
  props: {
    rowIndex: { type: Number, required: true },
    row: { type: Array },
    activeCellIndex: { type: Number },
    maxColumnIndex: { type: Number, required: true },
  },
})
